import {store} from "../redux/store";
import {setTatabanyaCardContent} from "../redux/actions/setTatabanyaCardContent";
import {getTatabanyaCardContent} from "../action/getTatabanyaCardContent";

export const tatabanyaCardLoader = async (args) => {
    store.dispatch(setTatabanyaCardContent(await getTatabanyaCardContent()))
    return true;
}
